import { DataItem } from "vis-timeline";
import { BaseMap } from "./BaseMap";
import { IMoveable } from "../Holders/BaseHolder";
import { AbilityMap } from "./index";
import { Utils, addSeconds } from "../Utils";
import * as Models from "../Models";

export interface IJobStanceMapData {
  start?: Date;
  end?: Date;
  loaded?: boolean;
  showLoaded?: boolean;
}

export class JobStanceMap extends BaseMap<string, DataItem, IJobStanceMapData> implements IMoveable {

  constructor(presenter: Models.IPresenterData, id: string, ability: AbilityMap, stanceAbility: Models.IAbility, data: IJobStanceMapData) {
    super(presenter, id);
    this.ability = ability;
    this.stanceAbility = stanceAbility;
    this.applyData(Object.assign({ loaded: false, showLoaded: false }, data));
  }

  get start(): Date {
    return this.item.start as Date;
  }

  set start(v: Date) {
    this.item.start = v;
  }

  get end(): Date {
    return this.item.end as Date;
  }

  set end(v: Date) {
    this.item.end = v;
  }

  ability: AbilityMap;
  stanceAbility: Models.IAbility;
  loaded: boolean;
  move(delta: number): boolean {
    const newDateStart = addSeconds(this.start, delta);
    const newDateEnd = addSeconds(this.end, delta);
    this.applyData({
      start: newDateStart,
      end: newDateEnd
    });
    return true;
  }

  onDataUpdate(data: IJobStanceMapData): void {
    this.setItem(this.createStanceUsage(this.stanceAbility, this.id, this.ability.id, data.start, data.end, data.loaded, data.showLoaded));
  }
  createStanceUsage(
    ability: Models.IAbility,
    id: string,
    parentId: string,
    start: Date,
    end: Date,
    loaded: boolean,
    showLoaded: boolean): DataItem {

    const title = `<img class='tooltipAbilityIcon' src='${ability.icon}'/>${ability.name}  ${Utils.formatTime(start)} - ${Utils.formatTime(end)}`;
    return {
      id,
      start,
      end,
      group: parentId,
      className: this.buildClass({ stance: true, loaded: loaded && showLoaded }),
      content: "<img class='abilityIcon' src='" + ability.icon + "'/>",
      subgroup: "sg" + parentId,
      type: "range",
      title,
    };
  }

  // case M.EntryType.StanceUsage:
  //   const sability = this.holders.abilities.get(item.group).ability;
  //   return (item.end as number) - (item.start as number) > 0 &&
  //     new Date(item.start) >= new Date(this.startDate.valueOf() as number - 30 * 1000) &&
  //     !sability.overlapStrategy.check({ ...overlapCheckData, ability });
}
